var Letter = React.createClass({
	mixins: [React.addons.PureRenderMixin],

	render: function () {
		return (
			<div>
				<div>
					<h1>Website Announcement</h1>
					<hr />
					Dear MOBC Community,
					<br />
					<br />
					I hope you are all doing well.
					<br />
					<br />
					I would like to take this opportunity to announce that on the <b className="specialy">6th of August, 2025</b>, we will be <b className="specialy">shutting down our servers</b>. It is a tough but necessary decision we had to take, and we apologize to those who will be inconvenienced by this. 
					<br />
					<br />
I am forever grateful for this community and everyone who has helped shape it into what it is today. Building, playing, and growing with all of you over the years has been an incredible journey. I hope you had fun, made friends, and continue to spread the same positivity that has kept this place alive for over five years. There are many other great gaming communities out there, and I wish you all the very best as you continue your adventures elsewhere.

					<br />
					<br />
					I would like to take a second to give a special shoutout to <a href="https://mobcpop.com/index.html#u/cynthiatx3"><b className="name">#u/cynthiatx3</b></a> and <a href="https://mobcpop.com/index.html#u/Matty J"><b className="name">#u/Matty J</b> </a>for their contributions to this site. Your time, effort, and dedication as admins were a huge part of keeping this site running and keeping the community thriving.
					<br />
					<br />With much love,{' '}<br />
					<a href="#u/vish" className="white">
						#u/vish
					</a>{' '}
				</div>
				<LetterSeeAlso />
			</div>
		)
	},
})
